import React, { useState } from 'react';
import { Popover } from 'reactstrap';
import { string } from '../../../localization';
import { Icons } from '../../../utilities/Icons/Icons';

export const LegalText = props => {
  const { finalCheck } = props;
  const { innerWidth: width } = window;
  const popOverWidth = width / 2;
  const [isHover, setIsHover] = useState(false);
  let textClassName = 'legal-click';
  if (finalCheck) {
    textClassName = 'legal-click-finalCheck';
  }

  return (
    <div style={{ paddingLeft: '5px' }}>
      <button
        type='button'
        style={{ border: 'none', outline: 'none', background: 'none' }}
        onMouseEnter={() => {
          setIsHover(true);
        }}
      >
        <img id='legalText' src={Icons.InfoDefault} alt='legal' />
      </button>
      <text className={textClassName}>{string.MASK_LEGAL_TEXT}</text>

      <Popover placement='bottom' isOpen={isHover} target='legalText'>
        <div
          style={{
            display: 'flex',
            width: `${popOverWidth}px`,
            height: '200px',
            borderStyle: 'groove',
            backgroundColor: 'white'
          }}
        >
          <textarea
            readOnly
            defaultValue={string.MASK_LEGAL_DETAILED_TEXT}
            style={{ width: '100%', borderStyle: 'none', resize: 'none' }}
          />
          <button
            type='button'
            style={{
              height: 'fit-content',
              border: 'none',
              outline: 'none',
              background: 'none'
            }}
            onKeyPress={() => {}}
            onClick={() => {
              setIsHover(false);
            }}
          >
            <img
              alt='close'
              style={{ margin: '4px 4px 0px 12px' }}
              className='closeModal'
              src={Icons.close}
            />
          </button>
        </div>
      </Popover>
    </div>
  );
};
